/**
 * Selector del repositorio.
 *
 * Con credenciales de Supabase se sirve el repositorio real; sin ellas, el de
 * demostracion. Es el unico sitio del proyecto que decide contra que backend
 * se habla: ninguna pagina importa Supabase directamente.
 */

import { env } from '@/config/env';

import { DemoRepository } from './demo/repository';
import { SupabaseRepository } from './supabase/repository';
import type { Repository } from './types';

let instance: Repository | null = null;

export function getRepository(): Repository {
  if (!instance) {
    instance = env.isDemoMode ? new DemoRepository() : new SupabaseRepository();
  }
  return instance;
}

export * from './types';
